import { Text, View } from '@react-pdf/renderer';
import React from 'react';
import FontAwesomeIcon from '../FontAwesomeIcon';
import ViewNoWidow from '../ViewNoWidow';
import { styles } from '../CandidateProfileResumePDF';
import {
	faBuilding,
	faMapMarkerAlt,
	faMedal
} from '@fortawesome/free-solid-svg-icons';

export default function CandidateProfileCertifications({ candidate }) {
	return (
		<View style={styles.section}>
			<ViewNoWidow style={styles.subheader} minPresenceAhead={65} wrap={false}>
				<View style={styles.iconContainer}>
					<FontAwesomeIcon
						faIcon={faMedal}
						style={{
							color: '#4258DD',
							width: '15px'
						}}
					/>
				</View>
				<Text>Certifications</Text>
			</ViewNoWidow>
			<View style={[styles.flexColumn, { gap: 16 }]}>
				{candidate.candidateCertifications
					?.filter(certification => !!certification.visible)
					?.map(certification => {
						return (
							<View
								style={[styles.flexRow, { gap: 4, alignItems: 'flex-start' }]}
								wrap={false}>
								<Text>{'\u2022 '}</Text>
								<View style={styles.flexColumn} wrap={false}>
									<Text style={styles.boldText}>{certification.degree}</Text>
									<View style={styles.flexRow}>
										<View
											style={[
												styles.flexRow,
												{ gap: 4, alignItems: 'center' }
											]}>
											<FontAwesomeIcon
												faIcon={faBuilding}
												style={{
													color: '#59F3D4',
													width: '9px'
												}}
											/>
											<Text>{certification.institution}</Text>
										</View>
										{certification.location && (
											<View
												style={[
													styles.flexRow,
													{ gap: 4, alignItems: 'center' }
												]}>
												<FontAwesomeIcon
													faIcon={faMapMarkerAlt}
													style={{
														color: '#59F3D4',
														width: '9px'
													}}
												/>
												<Text>{certification.location}</Text>
											</View>
										)}

										{certification.status === 'graduated' &&
										!certification.graduationYear ? null : (
											<View
												style={[
													styles.flexRow,
													{ gap: 4, alignItems: 'center' }
												]}>
												<FontAwesomeIcon
													faIcon={faMedal}
													style={{
														color: '#59F3D4',
														width: '13px'
													}}
												/>
												<Text>
													{certification.status === 'graduated'
														? certification.graduationYear
														: 'In Progress'}
												</Text>
											</View>
										)}
									</View>
								</View>
							</View>
						);
					})}
			</View>
		</View>
	);
}
